// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Uc0ai","largestCol":"styles_largestCol__3bEtQ","smallestCol":"styles_smallestCol__22loH"};